module.exports = __webpack_public_path__ + "img/slack.bd4a3d92.svg";